import EvalCard from './component'
export default EvalCard;



// WEBPACK FOOTER //
// ./src/components/bz/eval-card/index.js